import React, { useEffect, useState } from "react";
import "./App.css";
import { Layout, ConfigProvider, theme, Spin } from "antd";
import AppRoutes from "./routes/AppRoutes";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import {
  redeemHandoff,
  selectIdToken,
} from "./features/access-control/accountSlice";
import ErrorAlerter from "./features/errors/ErrorAlerter";
import { selectThemeMode } from "./features/theme/themeSlice";

const { Content } = Layout;

function App() {
  const isAuthenticated = useAppSelector(selectIdToken);
  const themeMode = useAppSelector(selectThemeMode);
  const dispatch = useAppDispatch();
  const [isRedeemingHandoff, setIsRedeemingHandoff] = useState(() =>
    new URLSearchParams(window.location.search).has("handoff")
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("handoff");
    if (!code) return;
    (async () => {
      try {
        await dispatch(redeemHandoff({ code })).unwrap();
      } catch {
      } finally {
        params.delete("handoff");
        const query = params.toString();
        window.history.replaceState(
          {},
          "",
          window.location.pathname + (query ? `?${query}` : "")
        );
        setIsRedeemingHandoff(false);
      }
    })();
  }, [dispatch]);

  if (isRedeemingHandoff) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin size="large" tip="Switching environment..." />
      </div>
    );
  }

  return (
    <ConfigProvider
      theme={{
        algorithm:
          themeMode === "dark" ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          colorPrimary: "#6B4EFF",
          borderRadius: 8,
          colorLink: "#6B4EFF",
          colorLinkHover: "#8970FF",
          fontFamily:
            "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
          colorBgContainer: "#ffffff",
          colorBgLayout: "#f5f5f5",
        },
      }}
    >
      <Layout style={{ minHeight: "100vh", background: "#f5f5f5" }}>
        <Content style={{ paddingTop: 64 }}>
          <div
            style={{
              padding: "24px",
              maxWidth: "1600px",
              margin: "0 auto",
              minHeight: "calc(100vh - 64px)",
            }}
          >
            <AppRoutes />
            <ErrorAlerter />
          </div>
        </Content>
      </Layout>
    </ConfigProvider>
  );
}

export default App;
